export default __webpack_public_path__ + "static/media/4.ad4bee92.jpg";